import type {
  BillingCadence,
  BillingPlan,
  PaymentMethodType,
} from "@app/common/types";

export const LABEL_FOR_PLAN: Record<BillingPlan, string> = {
  free: "Free",
  zoom_bundle_trial: "Essential Apps via Zoom",
  pro: "Pro",
  enterprise: "Enterprise",
  enterprise_plus: "Enterprise+",
  unknown: "",
};

export const TRUNCATED_LABEL_FOR_PLAN: {
  [key in BillingPlan]?: string;
} = {
  zoom_bundle_trial: "Zoom Apps",
};

export const LABEL_FOR_PAYMENT_METHOD_TYPE: {
  [key in PaymentMethodType]?: string;
} = {
  cashapp: "Cash App",
};

export const LABEL_FOR_CADENCE: Record<BillingCadence, string> = {
  monthly: "Monthly",
  annual: "Annual",
};
